/** @format */
import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { safeCurrentLanguage } from '@services/drupal-services';
import { sanitizeJson } from '@varian/scripts/services/string-transformation-services';
import Loader from '@components/loader';

const GoogleTreatmentLocationMap = lazy(
  () =>
    import(
      /* webpackChunkName: "google-treatment-location-map" */ './google-treatment-location-map'
    )
);

const BingTreatmentLocationMap = lazy(
  () =>
    import(
      /* webpackChunkName: "bing-treatnment-location-map" */ './bing-treatnment-location-map'
    )
);

export const treatmentLocationMap = () => {
  const locationJson: HTMLElement | null = document.querySelector(
    '.treatment-location'
  );
  if (locationJson) {
    const jsonData = sanitizeJson(locationJson.innerHTML);
    const { title, solutions, geoLocation } = jsonData;
    const [lattitude, longitude] = geoLocation.split(' ');
    const locatorContainer = document.getElementById(
      'varian-treatment-location-map'
    );
    const locatorMap =
      safeCurrentLanguage() === 'zh-hant' ||
      safeCurrentLanguage() === 'zh-hans' ? (
        <BingTreatmentLocationMap
          geolocation={{
            lattitude: parseFloat(lattitude),
            longitude: parseFloat(longitude),
          }}
          locationInfo={{ title, solutions }}
        />
      ) : (
        <GoogleTreatmentLocationMap
          geolocation={{
            lattitude: parseFloat(lattitude),
            longitude: parseFloat(longitude),
          }}
        />
      );

    if (locatorContainer) {
      const root = createRoot(locatorContainer);
      root.render(<Suspense fallback={<Loader />}>{locatorMap}</Suspense>);
    }
  }
};
